import React from 'react';
import { Button } from '@mui/material';

interface TimeoutDisplayProps {
  onRetry: () => void;
}

const TimeoutDisplay: React.FC<TimeoutDisplayProps> = ({ onRetry }) => {
  return (
    <div className="text-center p-4 border-2 border-red-200 rounded-lg animate-fade-in">
      <p className="text-md text-error mt-2">You must accept the security confirmation step on your phone. Please try again.</p>
      <Button
        className="text-contrastText"
        variant="contained"
        color="error"
        onClick={onRetry}
        fullWidth
      >
        Try Again
      </Button>
    </div>
  );
};

export default TimeoutDisplay; 